<template>
  <div class="view-selector hide-for-print" id="view-selector" :class="{ 'isFetching': (this.$store.state.fetching.length > 0) }">
    <ul class="options" v-if="!$store.state.covid19.is_enabled">
      <li :class="{ isActive: (viewMode == 'chart') }" class="options__item" @click="setViewmode('chart')">
        <div class="inner">
          Visualization
        </div>
      </li>
      <li :class="{ isActive: (viewMode == 'table') }" class="options__item" @click="setViewmode('table')">
        <div class="inner">
          Data
        </div>
      </li>
    </ul>
  </div>
  <!-- /.view-selector -->
</template>

<script>
export default {
  name: 'view-selector',
  computed: {
    viewMode () {
      return this.$store.state.viewMode
    }
  },
  watch: {
    '$store.state.covid19.is_enabled' () {
      if (this.$store.state.covid19.is_enabled) {
        this.$store.state.viewMode = 'chart'
      }
    }
  },
  methods: {
    setViewmode (mode) {
      if (this.$store.state.fetching.length === 0) {
        this.$store.state.viewMode = mode
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/typography';

  .view-selector{}

  .options{
    border-radius: 2px;
    display: flex; -js-display: flex;
    list-style: none;
    margin: 25px 0 25px 35px;
    padding: 0;
    .last-updated{
      padding:6px 15px;
    }
  }
  .options__item{
    flex: 1 1 auto;
    margin: 0;
    white-space: nowrap;
    max-width:100px;
  }

  .inner{
    background: $gray-lighter;
    align-items: center;
    cursor: pointer;
    display: flex; -js-display: flex;
    margin-top: 0;
    padding: 5px 10px;
    justify-content: center;
  }
  .isFetching .inner{
    cursor: default;
  }

  .cls-1{
    fill:none;
    stroke: $gray;
    stroke-miterlimit:10;
  }

  #viewselector-chart,
  #viewselector-table{
    height: 20px;
    width: 20px;
  }

  .options__item.isActive .inner{
    background: $gray-darkest;
    box-shadow: 2px 0 2px 0 rgba(47, 62, 94, 0.2);
    color: $white;
    cursor: auto;
    margin-top: 0;
    padding: 5px 10px;
    position: relative;
    z-index: 2;

    .cls-1{ stroke: $white; }

    #viewselector-chart,
    #viewselector-table{
      height: 20px;
      width: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/ViewSelector.vue